/** The column the groups are filtered by number of active projects, which is also its query param in the URL */
export const GROUPS_PROJECTS_FILTER_COLUMN = "projects";

/** The column the groups are filtered by number of managers, which is also its query param in the URL */
export const GROUPS_MANAGERS_FILTER_COLUMN = "members";

/** The column the groups are filtered by creation date, which is also its query param in the URL */
export const GROUPS_CREATED_FILTER_COLUMN = "createdDate";

/** The columns the groups can be filtered by, in the order of their chips. Each applies only one filter */
export const GROUPS_FILTER_COLUMNS = [GROUPS_PROJECTS_FILTER_COLUMN, GROUPS_MANAGERS_FILTER_COLUMN, GROUPS_CREATED_FILTER_COLUMN];

/** A column the groups can be filtered by */